import { ViewState } from 'react-map-gl/src/types/external';
import { getLocalStorageItem } from './storageUtils';

const PROJECT_MAP_VIEW_STATE_KEY = 'Replan.mapViewStateByProject';

export const getStorageMapViewStatesByProjectId = () =>
    getLocalStorageItem(PROJECT_MAP_VIEW_STATE_KEY);

export const addProjectStorageMapViewState = (projectId: string, viewState: ViewState) => {
    const storedViewStateByProjects = getStorageMapViewStatesByProjectId()[projectId];

    localStorage.setItem(
        PROJECT_MAP_VIEW_STATE_KEY,
        JSON.stringify({
            ...getStorageMapViewStatesByProjectId(),
            [projectId]: {
                ...storedViewStateByProjects,
                ...viewState,
            },
        })
    );
};

export const deleteProjectStorageMapViewState = (projectId: string) => {
    const { [projectId]: deletedMapViewState, ...restMapViewStatesByProject } =
        getStorageMapViewStatesByProjectId();
    localStorage.setItem(
        PROJECT_MAP_VIEW_STATE_KEY,
        JSON.stringify({
            ...restMapViewStatesByProject,
        })
    );
};
